<template>
<div class='container-center-horizontal-dance'>
    <span class='colortitle-dance title tamanhotitle'>{{$t('games.dance.song')}}</span>
    <div class='selector-filter'>
        <select class="filter-select backgroundfilter-dance tamanho0" v-model="filter_selected">
            <option v-for="option in filter_options" :value="option" :key="option">
                    {{ $t("games.shared.filter_options." + option) }}
            </option>
        </select>
        <select v-if="filter_selected !== 'all'" class="filter-select-option backgroundfilter-dance tamanho0" v-model="option_selected">
            <option v-for="option in options_possible" :value="option" :key="option">
                {{ $t("games.shared.filter_description." + filter_selected + "." + this.capitalizeWords(option.toString()).replace(' ', ''))  }}
            </option>
        </select>
    </div>
    <div class='button-list color-list-dance'>
        <div v-for="song in filtered_songs" :key="song.music_id" class='playlist colortext-dance tamanho0' :class="{ 'sel-dance' : selected == song.music_id }" @click="onClick(song.music_id)">
            <span class="musicName"> {{song.title}} </span>
            <span @click="playSelectedSong(song.midi)" class="tamanhoicon">
                <img v-if="playSign && current_midi == song.midi" :src="require('@/assets/buttons/newbuttons/dance/pause.svg')" />
                <img v-else :src="require('@/assets/buttons/newbuttons/dance/play.svg')" />
            </span>
        </div>
    </div>
    <MidiPlayer :midi="current_midi" :playMidi="play" :instrument="'Acoustic Guitar'" @finishedPlaying="stopSongs"></MidiPlayer>
</div>
</template>

<script>
import MidiPlayer from "@/components/General/MidiPlayer.vue";

export default {
    name: "ChooseSongDance",
    emits: ['chooseSong'],
    props: ['country'],
    components: {
        MidiPlayer,
    },
    data() {
        return {
            selected: '',
            current_midi: '',
            songs: [],
            play: false,
            playSign: false,

            filter_options: ['all', 'genre', 'rhythmic_level', 'meter_level'],
            filter_selected: 'all',
            options_possible: [],
            option_selected: '',
            filtered_songs: []
        }
    },
    watch: {
        filter_selected(val, oldVal) {
            if (!val || val === oldVal) return;

            let opts = this.selectable_values(val);

            this.option_selected = [...opts][0];
            this.options_possible = opts;

            this.filtered_songs = this.get_filtered_songs(val, this.option_selected);
        },
        option_selected(val, oldVal) {
            if (!val || val === oldVal) return;
            this.filtered_songs = this.get_filtered_songs(this.filter_selected, val);
        }
    },
    mounted() {
        this.fetchSongs();
    },
    methods: {
        onClick(num) {
            this.selected = num;
            console.log(num);
            this.$emit('chooseSong', num);
        },
        fetchSongs() {
            fetch(process.env.VUE_APP_API_URL + "/musicByCountryWithRhythmLevels/" + this.country, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        Accept: "application/json, text/plain, */*",
                    },
                    method: "GET",
                })
                .then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    if (!devs[0].msg) {
                        this.songs = devs;
                        this.filtered_songs = this.get_filtered_songs('all', '');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        playSelectedSong(midi) {

            if (this.playSign == true) {
                this.stopSongs();
            } else {
                this.current_midi = midi;
                this.playSign = true;
            }

            this.play = !this.play;
        },
        stopSongs() {
            this.playSign = false;
        },
        selectable_values(filter) {
            if (filter === 'all') {
                return [];
            } else {
                let possibilities = new Set(this.songs.map((obj) => {
                    return obj[filter];
                }));
                return possibilities;
            }
        },
        get_filtered_songs(filter, option) {
            if (filter === 'all') {
                return this.songs;
            }

           return this.songs.filter((obj) => {
                return obj[filter] === option;
            });
        }
    },
     updated(){
        this.counterMusics = Math.round(document.getElementsByClassName('playlist colortext-dance tamanho0').length);
        this.finalcount= Math.round(this.counterMusics/3);
        document.getElementsByClassName('button-list')[0].style.gridTemplateRows = 'repeat('+this.finalcount+', 49%)';
    }
};
</script>

<style>
.sel-dance {
    background: rgba(245, 209, 209, 0.7) !important;
}
.colortext-dance{
    color:#630E0E;
}
.backgroundfilter-dance {
     background: #CD1719;
}
.color-list-dance::-webkit-scrollbar {
    width: 10px;
    height: 100%;
}

.color-list-dance::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 10px;
}

.color-list-dance::-webkit-scrollbar-thumb {
    background: #CD1719;
    border-radius: 10px;
}

.selector-filter-dance {
    position: absolute;
    right: 10%;
    top: 22%;
}

.filter-select-dance, .filter-select-option-dance {
    background: #CD1719;
    border-radius: 30px;
    color: rgba(255, 255, 255, 1.0) !important;
}
</style>
